import Repository from "./Repository";

const resource = "/dashboard";

export default {
  getCounts() {
    return Repository.get(`${resource}/Counts`, { withCredentials: true });
  },
  getAllergenCoverage() {
    return Repository.get(`${resource}/AllergenCoverage`, { withCredentials: true });
  },
  getCaloriesBreakdown() {
    return Repository.get(`${resource}/CaloriesBreakdown`, { withCredentials: true });
  },
  getUsageSummary() {
    return Repository.get(`${resource}/UsageSummary`, { withCredentials: true });
  },
};
